module.exports = __webpack_public_path__ + "static/media/logomark.0d709096.svg";